var _jsxFileName = "/home/runner/_work/smpackages/smpackages/packages/webassets/src/components/Header/components/JoinTeamCTA/index.tsx",
  _this = this;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { T, defineMessages } from '@sm/intl';
import { MetricsTracker, USER_EVENTS } from '@sm/metrics';
import { createURL } from '@sm/utils';
import { Button } from '@wds/button';
import React from 'react';
var COPY = defineMessages({
  JOIN_TEAM: {
    id: 'JoinTeamCTA.JoinTeam',
    defaultMessage: 'Join team',
    description: '[Type: Label][Vis: High] - Join team button in the header'
  }
});
var JoinTeamCTA = function JoinTeamCTA(_ref) {
  var joinTeamSlug = _ref.joinTeamSlug,
    className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'sm' : _ref$size,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'solid' : _ref$variant,
    _ref$stretched = _ref.stretched,
    stretched = _ref$stretched === void 0 ? false : _ref$stretched,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'primary' : _ref$color,
    _ref$amplitudeProps = _ref.amplitudeProps,
    amplitudeProps = _ref$amplitudeProps === void 0 ? {} : _ref$amplitudeProps;
  var handleClick = function handleClick() {
    MetricsTracker.track({
      name: USER_EVENTS.ELEMENT_INTERACTION,
      data: _objectSpread({
        amplitudeEvent: 'join team clicked button'
      }, amplitudeProps)
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Button, {
    size: size,
    variant: variant,
    stretched: stretched,
    color: color,
    target: "_blank",
    href: createURL("/request-team-seat/".concat(joinTeamSlug)),
    onClick: handleClick,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 52,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.JOIN_TEAM,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 61,
      columnNumber: 9
    }
  })));
};
export default JoinTeamCTA;
//# sourceMappingURL=index.js.map